//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum FixedDRounding {
	Previuous = 0,
	Next = 1,
	Math = 2
}
